// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoTooltip_wrapper__5QTOm","icon":"InfoTooltip_icon__RWSdo","tooltip":"InfoTooltip_tooltip__6eDyX","above":"InfoTooltip_above__uEyVw","below":"InfoTooltip_below__1iGkn"};